var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIconFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.15 5.05H5.85V3.75H7.15M7.15 10.25H5.85V6.35H7.15M6.5 0.5C5.64641 0.5 4.80117 0.668127 4.01256 0.994783C3.22394 1.32144 2.50739 1.80023 1.90381 2.40381C0.684819 3.62279 0 5.27609 0 7C0 8.72391 0.684819 10.3772 1.90381 11.5962C2.50739 12.1998 3.22394 12.6786 4.01256 13.0052C4.80117 13.3319 5.64641 13.5 6.5 13.5C8.22391 13.5 9.87721 12.8152 11.0962 11.5962C12.3152 10.3772 13 8.72391 13 7C13 6.14641 12.8319 5.30117 12.5052 4.51256C12.1786 3.72394 11.6998 3.00739 11.0962 2.40381C10.4926 1.80023 9.77606 1.32144 8.98744 0.994783C8.19883 0.668127 7.35359 0.5 6.5 0.5Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIconFilled);
export default __webpack_public_path__ + "static/media/info_icon_filled.40bd59399be1040c76b1a3b23997eee0.svg";
export { ForwardRef as ReactComponent };